import { useRouter } from 'next/router'
import { useMemo } from 'react'

export const useQueryParams = () => {
  const { asPath } = useRouter()

  const params = useMemo(() => {
    const queryString = asPath.split('?')[1]
    return new URLSearchParams(queryString)
  }, [asPath])

  return {
    params
  }
}
